import {useCallback, useMemo} from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import {Button} from 'components/Button';
import {useRouter} from 'next/router';
import {BrowserFilters} from 'plugins/modules/filter/helpers/BrowserFilters';
import {isBrowserContext} from 'core/helpers';
import classNames from 'classnames';
import {EventAction} from 'modules/google-analytics/constants';
import {useFiltersGtag} from 'hooks/analytics/gtag/catalog/useFiltersGtag';

export const EmptyProductList = () => {
    const router = useRouter();

    const sendFiltersGtag = useFiltersGtag();

    const filterInstance = useMemo(() => {
        if (!isBrowserContext()) {
            return null;
        }

        return BrowserFilters.getInstance();
    }, []);

    const handleDiscard = useCallback(() => {
        if (!filterInstance) {
            return;
        }

        sendFiltersGtag(undefined, EventAction.RemoveAllFilters, undefined);

        const {pathName} = filterInstance.userRemoveAllFilters();
        router.push(pathName, undefined, {shallow: true});
    }, [filterInstance, router, sendFiltersGtag]);

    return (
        <div className={style.container}>
            <Typography className={classNames(style.listTitle, style.bigScreen)} color={'gray100'}>
                Мы не нашли товары по этому запросу
            </Typography>
            <Typography className={classNames(style.listTitle, style.smallScreen)} color={'gray100'}>
                Мы не нашли товары <br /> по этому запросу
            </Typography>
            <Typography className={style.advice} color={'gray100'} element={'div'} variant={'body-16-r'}>
                Попробуйте выбрать другую винотеку, изменить или сбросить фильтры
            </Typography>
            <Button
                backColor={'gray'}
                className={style.resetButton}
                onClick={handleDiscard}
                size={'medium'}
                theme={'primary'}
            >
                Сбросить фильтры
            </Button>
        </div>
    );
};
